import React from "react";
import './add-clicker-set.scss';
import { getImageSource } from "../../../utility/image-source";
import { ImageConstants } from "../../../constants/constants";
import SchoolApi from "../../../apis/school";
import DropdownV3 from "../../common/dropdown-v3/dropdown";
import ToasterComponent from "../../common/cw-toaster-component/cw-toaster-component";


class AddClickerSet extends React.Component {

    state = {
        schoolsDropdownList: [],
        selectedSchoolId: '',
        filter: {},
        clickerInfo: {},
        clickerSetList: [],
        isValid: false,
        isSubmit: false,
        isUpdate: false,
        isReload: true
    }

    constructor(props) {
        super(props)
    }

    limit = 10
    currentPage = 1
    clickerSetHash = {}
    schoolsHash = {}

    componentDidMount() {
        this.getSchools()
    }


    getSchools(filters = {}) {
        let payload = { ...filters }
        if (!payload.limit) payload.limit = this.limit
        if (!payload.page) payload.page = this.currentPage

        this.currentPage = payload.page
        if (this.currentPage === 1) this.startIndex = 1

        SchoolApi.getSchoolWithPagination(payload).then(response => {
            let items = []
            response.response.forEach(element => {
                items.push({ title: element.name, value: element.schoolCode })
                this.schoolsHash[element.schoolCode] = element
            });
            // console.log(items)
            this.setState({ schools: response.response, schoolsDropdownList: items, meta: response.meta })
        }).catch(err => {
            console.log("Error", err)
        })
    }

    getClickerSetList(count) {
        SchoolApi.getClickerSetList({}).then(res => {
            // console.log(res)

            let clickerSetList = res.clickerSet.splice(0, +count)

            console.log(clickerSetList)

            this.setState({ clickerSetList })

        }).catch(err => {
            console.log(err)
        })
    }

    onSearch(value, key) {
        let filter = this.state.filter
        filter[key] = value
        this.setState({ filter }, () => {
            if (!value || value.length >= 3) {
                this.getSchools({ ...filter, page: 1 })
            }
        })
    }

    onChangeHandler(e, key, item) {
        let value = e.target.value
        let clickerInfo = this.state.clickerInfo
        console.log('called...')
        if (value === '0') {
            value = null
        }

        clickerInfo[key] = value
        this.setState({ clickerInfo }, () => {
            this.getClickerSetList(value)
        })
    }

    onChangeCount(e, key, item, index) {
        let value = e.target.value
        console.log(value, item)

        let clickerSetHash = this.clickerSetHash

        if (!clickerSetHash[item._id]) {
            clickerSetHash[item._id] = {
                [key]: value
            }
        } else {
            console.log(key)
            console.log(clickerSetHash)
            clickerSetHash[item._id][key] = value
        }

        this.clickerSetHash = clickerSetHash
        this.setState({ selectedIndex: index })
        // this.validatePayload()
        // console.log(this.clickerSetHash)

    }






    validatePayload = () => {

        let isValid = false, isSubmit = true

        console.log(!this.state.clickerInfo.schoolId)

        if (!this.state.clickerInfo?.schoolId) {
            return this.setState({ errorMessage: "Please Select School", isSubmit, isValid })
        }

        if (!this.state.clickerInfo?.setCount) {
            return this.setState({ errorMessage: "Please Select How Many Set of Clickers", isSubmit, isValid })
        }



        for (let i = 0; i < this.state.clickerSetList.length; i++) {
            let setItem = this.state.clickerSetList[i]
            console.log(setItem)
            let clickerCount = this.clickerSetHash[setItem._id]
            console.log(clickerCount)
            if (!clickerCount) {
                this.setState({ errorMessage: `Please enter Number of Clicker in ${setItem.title}`, isSubmit, isValid })
                break;
            }

            if (clickerCount && !clickerCount.clickerCount) {
                this.setState({ errorMessage: `Please enter Number of Clicker in ${setItem.title}`, isSubmit, isValid })
                break;
            }

            if (i === this.state.clickerSetList.length - 1) {
                isValid = true
            }
        }
        // console.log('here')

        if (!isValid) {
            return
        }

        this.setState({ isValid: true, isSubmit: true })

        return true

    }


    generateClickerSet() {

        let isValid = this.validatePayload()
        if (!isValid) {
            return
        }

        let payload = this.preparePayload()

        console.log(payload)

        payload.isUpdate = this.state.isUpdate

        SchoolApi.addClickerSet(payload).then(res => {
            // console.log(res)

            // this.clickerSetHash = {}

            // let clickerInfo = this.state.clickerInfo

            // clickerInfo.schoolId = ""
            // clickerInfo.setCount = 0

            this.setState({ isSubmit: false, isValid: false, isReload: false }, () => {
                this.setState({ isReload: true })
            })

            // console.log(clickerInfo)

            if (this.state.isUpdate) {
                this.showToaster('info', `School Clicker Set Updated Successfully`)
            } else {
                this.showToaster('info', `School Clicker Set Added Successfully`)
            }

        }).catch(err => {
            console.log(err)
        })

    }


    preparePayload() {

        let payload = {
            setCount: this.state.clickerInfo.setCount,
            schoolId: this.state.clickerInfo.schoolId
        }

        let setList = {}

        for (let i = 0; i < this.state.clickerSetList.length; i++) {
            let setItem = this.state.clickerSetList[i]
            let clickerCount = this.clickerSetHash[setItem._id]
            setList[setItem._id] = {
                setId: setItem._id,
                setName: setItem.title,
                studentClickerList: clickerCount && clickerCount.studentClickerList?.length ? clickerCount.studentClickerList : [],
                teacherClickerId: clickerCount?.teacherClickerId ? clickerCount.teacherClickerId : "",
                allStudentClickerKeysTestDone: false,
                teacherClickerKeysTestDone: false,
                clickerCount: clickerCount.clickerCount,
                teacherClickerCount : clickerCount.teacherClickerCount
            }
        }

        payload.setList = setList


        return payload
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 8000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }




    onSelectSchool(option) {

        console.log(option, this.schoolsHash)

        let isUpdate = false

        let clickerInfo = this.state.clickerInfo


        if (!this.schoolsHash[option?.value]) {
            this.clickerSetHash = {}

            let clickerInfo = this.state.clickerInfo

            clickerInfo.schoolId = ""
            clickerInfo.setCount = 0
            this.setState({ clickerInfo })
        }

        if (option === null) {
            clickerInfo['schoolId'] = null
            clickerInfo['setCount'] = 0
            this.clickerSetHash = {}
        } else {
            clickerInfo['schoolId'] = option?.value
            if (this.schoolsHash[option?.value] && this.schoolsHash[option?.value].clicker &&
                this.schoolsHash[option?.value].clicker.setCount) {
                isUpdate = true
                let clicker = this.schoolsHash[option?.value].clicker
                this.getClickerSetList(clicker.setCount)
                for (let key in clicker.setList) {
                    this.clickerSetHash[key] = clicker.setList[key]
                }
                console.log(this.clickerSetHash)
                clickerInfo['setCount'] = clicker.setCount
            }
        }
        console.log(clickerInfo)
        this.setState({ clickerInfo, isUpdate })
    }

    onClickBack() {
        this.props.delegate && this.props.delegate.hideAddClickerSet && this.props.delegate.hideAddClickerSet()
    }


    render() {
        return (
            <div className="add-clicker-set">
                <div className="mb-3">
                    <img alt="" className='report-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                </div>
                <div className=''>
                    <span className='screen-title'>Add / Edit School Set</span>
                </div>

                <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                        <div className="filter-input-label">
                            School Name<span className='text-danger'>*</span>
                        </div>
                        {
                            this.state.isReload ?
                                <div className={`${this.state.isSubmit && !this.state.clickerInfo?.schoolId ? 'error-border' : ''}`}>
                                    <DropdownV3
                                        key="title"
                                        placeholder='Search School Name'
                                        options={this.state.schoolsDropdownList}
                                        onSelect={(option) => this.onSelectSchool(option)}
                                        text="title"
                                        onSearch={(value) => this.onSearch(value, 'search')}
                                        // style={{ background: "#F6F7F5" }}
                                        value={this.state.clickerInfo?.schoolId ? this.state.clickerInfo?.schoolId : null}
                                    />
                                </div>
                                :
                                <></>
                        }

                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                        <div className="filter-input-label">
                            How Many Sets of Clicker <span className='text-danger'>*</span>
                        </div>
                        <div>
                            <input
                                className='cw-input search-input'
                                placeholder='Enter Set Count'
                                style={{ background: "#FFFFFF" }}
                                onChange={e => this.onChangeHandler(e, 'setCount')}
                                value={this.state.clickerInfo?.setCount}
                                type="number"
                                min="0"
                                max="5"
                            />
                        </div>
                    </div>
                </div>
                {
                    this.state.clickerInfo?.setCount ?
                        <div className="mt-3 pl-3">
                            <div className="clicker-set-title">How Many Clicker in Each Set </div>
                            <div className="mt-3">
                                {
                                    this.state.clickerSetList.length && this.state.clickerSetList.map((item, index) => (
                                        <div className="row mt-3 align-items-center">
                                            <div className="col-1 mr-0 pr-0 filter-input-label">{item.title}</div>
                                            
                                            {
                                                this.state.selectedIndex === index ?
                                                    <>
                                                        <div className="ml-3 col-2 ml-0 pl-0">
                                                        {
                                                                index === 0 ? <div className="mb-2 clicker-set-title">Student Clicker Count</div> : ''
                                                            }
                                                            <input
                                                                className='cw-input search-input'
                                                                placeholder='Enter clicker Count'
                                                                style={{ background: "#FFFFFF" }}
                                                                onChange={e => this.onChangeCount(e, 'clickerCount', item, index)}
                                                                value={this.clickerSetHash[item._id] ? this.clickerSetHash[item._id]['clickerCount'] : null}
                                                                type="number"
                                                                min="0"
                                                                max="100"
                                                            />
                                                        </div>

                                                        <div className="ml-3 col-2 ml-0 pl-0">
                                                        {
                                                                index === 0 ? <div className="mb-2 clicker-set-title">Teacher Clicker Count</div> : ''
                                                            }
                                                            <input
                                                                className='cw-input search-input'
                                                                placeholder='Enter clicker Count'
                                                                style={{ background: "#FFFFFF" }}
                                                                onChange={e => this.onChangeCount(e, 'teacherClickerCount', item, index)}
                                                                value={this.clickerSetHash[item._id] ? this.clickerSetHash[item._id]['teacherClickerCount'] : null}
                                                                type="number"
                                                                min="0"
                                                                max="100"
                                                            />
                                                        </div>
                                                    </>


                                                    :
                                                    <>
                                                        <div className="ml-3 col-2 ml-0 pl-0">
                                                            {
                                                                index === 0 ? <div className="mb-2 clicker-set-title">Student Clicker Count</div> : ''
                                                            }
                                                        
                                                            <input
                                                                className='cw-input search-input'
                                                                placeholder='Enter clicker Count'
                                                                style={{ background: "#FFFFFF" }}
                                                                onChange={e => this.onChangeCount(e, 'clickerCount', item, index)}
                                                                value={this.clickerSetHash[item._id] ? this.clickerSetHash[item._id]['clickerCount'] : null}
                                                                type="number"
                                                                min="0"
                                                                max="100"
                                                            />
                                                        </div>
                                                        <div className="ml-3 col-2 ml-0 pl-0">
                                                            {
                                                                index === 0 ? <div className="mb-2 clicker-set-title">Teacher Clicker Count</div> : ''
                                                            }
                                                        
                                                            <input
                                                                className='cw-input search-input'
                                                                placeholder='Enter clicker Count'
                                                                style={{ background: "#FFFFFF" }}
                                                                onChange={e => this.onChangeCount(e, 'teacherClickerCount', item, index)}
                                                                value={this.clickerSetHash[item._id] ? this.clickerSetHash[item._id]['teacherClickerCount'] : null}
                                                                type="number"
                                                                min="0"
                                                                max="100"
                                                            />
                                                        </div>
                                                    </>
                                            }

                                        </div>
                                    ))
                                }
                            </div>

                            {!this.state.isValid && this.state.isSubmit && <div className="invalid-message">{this.state.errorMessage}</div>}

                            {
                                this.state.isValid ?
                                    <div className="cursor-pointer d-flex align-items-center justify-content-center text-center save-button d-inline-block cw-button-primary" onClick={() => this.generateClickerSet()}>Save</div>
                                    :
                                    <div className="d-flex align-items-center justify-content-center text-center save-button d-inline-block disable-button" onClick={() => this.generateClickerSet()} >Save</div>
                            }
                        </div>
                        :
                        <></>
                }
                {this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent image={this.state.toasterImage} message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" /></div> : ""}
            </div>
        )
    }

}

export default AddClickerSet;